import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1 } from '@cian/ui-kit';
import { plural } from '@cian/utils';
import { Documentation as DocumentationComponent } from '../../components/Documentation';
import { getDocumentation } from '../../selectors';
import { Link } from '../../components/Link';
import { ShowMoreLink } from '../../components/ShowMoreLink';

const MAX_VISIBLE_DOCUMENTS = 4;

export function Documentation() {
  const [showAll, setShowAll] = React.useState(false);
  const documentation = useSelector(getDocumentation);

  const documentationForRender = React.useMemo(
    () => (showAll ? documentation : documentation.slice(0, MAX_VISIBLE_DOCUMENTS)),
    [documentation, showAll],
  );
  const remainingDocumentation = documentation.length - documentationForRender.length;
  const list = React.useMemo(
    () => documentationForRender.map(doc => <Link key={doc.id} url={doc.url} text={doc.title} size="M" />),
    [documentationForRender],
  );

  const handleShowAll = React.useCallback(() => setShowAll(true), []);

  if (!documentation || !documentation.length) {
    return null;
  }

  return (
    <DocumentationComponent
      title={<ArticleHeading1>Документация</ArticleHeading1>}
      documentation={list}
      showMore={
        !showAll && documentation.length > MAX_VISIBLE_DOCUMENTS ? (
          <ShowMoreLink onClick={handleShowAll}>
            Еще {remainingDocumentation} {plural(remainingDocumentation, ['документ', 'документа', 'документов'])}
          </ShowMoreLink>
        ) : null
      }
    />
  );
}
